import React, { useEffect, useState } from 'react'
import { Modal } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'

interface CommonDialogPropsInterface {
  open: boolean
  onDialogClose: any
  dialogContent: any
  title: any
  width?: string
}

const CommonDialog = (props: CommonDialogPropsInterface) => {
  const [open, setOpen] = useState(props.open)

  useEffect(() => {
    setOpen(props.open)
  }, [props.open])

  const onClose = () => {
    props.onDialogClose(false)
  }

  return (
    <>
      <Modal
        title={
          <div style={{
            color: '#1B3B2E',
            fontSize: '18px',
            fontWeight: 600,
            padding: '4px 0'
          }}>
            {props.title || ''}
          </div>
        }
        centered={true}
        width={props.width ? props.width : "98%"}
        style={{ marginTop: '0.5rem', maxWidth: '95vw', top: '10px' }}
        visible={open}
        onCancel={onClose}
        footer={null}
        maskClosable={false}
        destroyOnClose={true}
        closeIcon={
          <CloseCircleOutlined 
            style={{
              fontSize: '24px',
              color: '#8BC9A3',
              transition: 'all 0.3s ease',
              marginRight: '8px'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#6FB890'
              e.currentTarget.style.transform = 'rotate(90deg)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#8BC9A3'
              e.currentTarget.style.transform = 'rotate(0deg)'
            }}
          />
        }
      >
        {props.dialogContent}
      </Modal>

      {/* Custom Modal Styles */}
      <style>{`
        /* Modal Header Styling */
        .ant-modal-header {
          background: linear-gradient(to right, #ffffff 0%, #f9fdfb 100%) !important;
          border-bottom: 2px solid #8BC9A3 !important;
          border-radius: 8px 8px 0 0 !important;
          padding: 16px 24px !important;
        }

        /* Modal Content */
        .ant-modal-content {
          border-radius: 12px !important;
          box-shadow: 0 4px 24px rgba(27, 59, 46, 0.15) !important;
          border: 1px solid #e8f5ed !important;
          overflow: hidden;
        }

        /* Modal Body */
        .ant-modal-body {
          padding: 24px !important;
          background-color: #ffffff !important;
          max-height: calc(100vh - 120px);
          overflow-y: auto;
        }

        /* Custom Scrollbar for Modal Body */
        .ant-modal-body::-webkit-scrollbar {
          width: 8px;
        }

        .ant-modal-body::-webkit-scrollbar-track {
          background: #f9fdfb;
          border-radius: 4px;
        }

        .ant-modal-body::-webkit-scrollbar-thumb {
          background: #8BC9A3;
          border-radius: 4px;
          transition: all 0.3s ease;
        }

        .ant-modal-body::-webkit-scrollbar-thumb:hover {
          background: #6FB890;
        }

        /* Modal Close Button */
        .ant-modal-close {
          top: 16px !important;
          right: 16px !important;
        }

        .ant-modal-close:hover {
          background-color: rgba(139, 201, 163, 0.1) !important;
          border-radius: 50%;
        }

        /* Modal Mask */
        .ant-modal-mask {
          background-color: rgba(27, 59, 46, 0.45) !important;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .ant-modal {
            max-width: calc(100vw - 32px) !important;
            margin: 16px auto !important;
          }

          .ant-modal-header {
            padding: 12px 16px !important;
          }

          .ant-modal-body {
            padding: 16px !important;
          }

          .ant-modal-close {
            top: 12px !important;
            right: 12px !important;
          }
        }

        @media (max-width: 480px) {
          .ant-modal {
            max-width: calc(100vw - 16px) !important;
          }

          .ant-modal-body {
            max-height: calc(100vh - 100px);
          }
        }
      `}</style>
    </>
  )
}

export default CommonDialog